module.exports = __webpack_public_path__ + "static/media/coffeesmall.7f38c15f.png";